<template>
  <div>
    <h3><el-page-header @back="$router.push('../.')" :content="title" /></h3>

    <el-row :gutter="20">
      <el-col :span="18">
        <div id="map" style="min-height: 680px; border: solid 1px #ccc"></div>
      </el-col>
      <el-col :span="6">
        <el-button type="primary" size="small" @click="save"
          >保存园区地理数据</el-button
        >
        <h4>操作说明</h4>
        <p style="line-height: 180%; color: #666">
          用鼠标拖动边界上的点到正确位置，编辑完成后点击上方“保存”按钮即可完成。
        </p>
        <p style="line-height: 180%; color: #666">
          如果该园区此前从未绘制地理边界，那么请先拖动和缩放地图，找到园区所在大致位置之后，点击
          <el-link :disabled="radio2" type="danger" @click="showMap">这里</el-link>
          初始化一个边界，然后即可编辑。
        </p>
        <p style="line-height: 180%; color: #666">
          小贴士：用鼠标按住地图拖动，可移动地图；用鼠标滚轮上下滚动，可改变地图比例尺。
        </p>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import map from './map.js'
import { parkUpdate } from '@/api/park.js'
import { getPark } from '@/api/park2.js'

export default {
  name: 'ParkLocate',
  data() {
    return {
      radio2: true
    }
  },
  computed: {
    /**
     * 当前地块的id
     */
    id() {
      return this.$route.params.id
    },
    title() {
      return `定位和绘制园区 ` // id = ${this.$route.params.id}
    },
  },
  created() {
    this.parkDateGet()
    // 当前地块的轮廓地理数据。应该先调用相关api提取当前地块的信息，其中包含了轮廓字段。
    const outline = undefined

    // console.log('【↑↑↑】', this.$options.name)
  },
  methods: {
    // 关闭编辑
    closeEdit() {},
    // 保存
    save() {
      //  BMapProxy('outline')
      var id = this.$route.params.id
      var array = map.getPosition()
      let option = {}
      option.id = this.$route.params.id
      option.position = array[0]
      option.lng = array[1]
      option.lat = array[2]

      parkUpdate(id, option).then((data) => {
        console.log('数据为' + data)
        // this.areaId = undefined
        // // this.landSearch()
        // this.dialogFormVisible = false
        // this.$refs['form'].resetFields()
        this.$message.success('提交成功')
      })
    },
    // 重置
    repalce() {
      // LocateMap().then(r=>{
      //   console.log(r)
      // })
    },
    parkDateGet() {
      var id = this.$route.params.id
      getPark(id).then((data) => {
        console.log('园区数据为：', data.data[0])
        // 初始化地图
        map.init('map', false, data.data[0])
        if (data.data[0].position == null) {
          console.log(this.radio2, 'this.radioo2')
          this.radio2 = false
        }
        // this.parks = data.data.list
        // this.total = data.data.total
        //     map.init('mapDiv',true,this.parks )
      })
    },
    showMap() {
      map.drawOutline()
      this.radio2 = true
    },
  },
  beforeDestroy() {
    map.destroy()
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/meta/park/Locate.vue